module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMElEQVQ4T6WSsUoEMRCGkzWWVja2KtgcnBzMJrFYF2Tfxuex8wV8BrdZLQzJrKhwhSIIVjZWsiCYTSSHK3t7e3fcXbpkZr7/n5lQsuGh3XpEfCWEHHrvfyil24SQGgDYPJ0pACKG5K1ustb6yjl3KaW87sb+AYjoAWDGUVOAiBcAcN4LyPN8N8uyz2Xj6BOZKCLiFwDsbAJYaL/Vxg0AnLaFJg6MMR9xHO+t7SAUaq0HnPPxIggijgFgMOPgbw7LttAbn1pbWZbf1tqhEOKlUfHe07IsXbg750ac84deB+1HY8wzpfSIEGLruj4TQtwaY0aU0ntr7YmUUjX5cz9O3yyUUpIxdmetPZZSPoWclQChQCk1ZIw9VlV1kKbp28qAACmKYj+KojpJkve1AO32fgG4yIYREKcpvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.png
// module id = NzrC
// module chunks = 2